import {
  upDateStores,
  upDateStoresInfo,
  fetchStoreList,
  fetchStoreCustomersList,
  fetchStoreInfo
} from '@/api/stores';

const stores = {
  state: {
  },

  mutations: {
  },

  actions: {
    // 开通商店
    UpDateStores({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        upDateStores(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 获取商店信息
    GetStoresInfo({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchStoreInfo(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 修改商店信息
    UpDateStoresInfo({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        upDateStoresInfo(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 获取商店列表
    GetStoreList({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchStoreList(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 获取商店客户列表
    GetStoreCustomersList({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchStoreCustomersList(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default stores;



// WEBPACK FOOTER //
// ./src/store/modules/stores.js